import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "mb-15" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
}, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-primary" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end" }
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t('feature.auth.$invitation.pending_invitations')), 1 /* TEXT */),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('feature.auth.$invitation.pending_invitations_message')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.invites === undefined)
          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
              key: 0,
              class: "mt-50"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('feature.auth.$invitation.invitation_expires_date')), 1 /* TEXT */),
                    _hoisted_9
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createCommentVNode(" CENTER ROW "),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invites, (invite) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: 'tr_invite_' + invite.recipient_email
                    }, [
                      _createElementVNode("td", _hoisted_10, _toDisplayString(invite.recipient_email), 1 /* TEXT */),
                      _createElementVNode("td", {
                        class: _normalizeClass(["shadow-none lh-1 fw-medium text-black-emphasis", [{ 'text-muted': _ctx.expired(invite) }]])
                      }, _toDisplayString(_ctx.YYYYMMDD_HHmm(invite.expires_at)), 3 /* TEXT, CLASS */),
                      _createElementVNode("td", _hoisted_11, [
                        (_ctx.loading === invite.recipient_email)
                          ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                              key: 0,
                              class: "h-auto",
                              style: {"justify-content":"end"}
                            }))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.expired(invite))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "default-btn transition fw-medium text-white px-3 py-2 fs-md-15 fs-lg-16",
                                    onClick: ($event: any) => (_ctx.resend(invite))
                                  }, _toDisplayString(_ctx.$t('feature.auth.$invitation.resend_invitation')), 9 /* TEXT, PROPS */, _hoisted_12))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ])
              ])
            ]))
      ])
    ]),
    _createVNode(_component_AlertModal, {
      id: "successModal",
      title: _ctx.$t('feature.auth.invitation'),
      dismissible: false,
      message: _ctx.$t('feature.auth.$invitation.send_success_message'),
      onConfirm: _ctx.redirect
    }, null, 8 /* PROPS */, ["title", "message", "onConfirm"]),
    _createVNode(_component_AlertModal, {
      id: "errorModal",
      title: _ctx.$t('feature.auth.invitation'),
      message: _ctx.errorMessage
    }, null, 8 /* PROPS */, ["title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}